import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.number.constructor.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = ["onClick"];
import { TUITranslateService, TUIStore, StoreName, TUIChatService } from "@tencentcloud/chat-uikit-engine";
import { ref } from "../../../../adapter-vue";
import ToolbarItemContainer from "../toolbar-item-container/index.vue";
import evaluateIcon from "../../../../assets/icon/evaluate.svg";
import Link from "../../../../utils/documentLink";
import Icon from "../../../common/Icon.vue";
import starIcon from "../../../../assets/icon/star.png";
import starLightIcon from "../../../../assets/icon/star-light.png";
import { CHAT_MSG_CUSTOM_TYPE } from "../../../../constant";
import { isPC, isH5, isUniFrameWork } from "../../../../utils/env";
import { isEnabledMessageReadReceiptGlobal } from "../../utils/utils";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    starTotal: {
      type: Number,
      "default": 5
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var container = ref();
    var starList = ref(props.starTotal);
    var currentStarIndex = ref(-1);
    var comment = ref("");
    var _currentConversation = ref();
    TUIStore.watch(StoreName.CONV, {
      currentConversation: function currentConversation(conversation) {
        _currentConversation.value = conversation;
      }
    });
    var onDialogClose = function onDialogClose() {
      resetEvaluate();
    };
    var openLink = function openLink(link) {
      if (isPC || isH5) {
        var _Link$customMessage;
        window.open(Link === null || Link === void 0 || (_Link$customMessage = Link.customMessage) === null || _Link$customMessage === void 0 ? void 0 : _Link$customMessage.url);
      }
    };
    var closeDialog = function closeDialog() {
      var _container$value;
      container === null || container === void 0 || (_container$value = container.value) === null || _container$value === void 0 || _container$value.toggleDialogDisplay(false);
    };
    var resetEvaluate = function resetEvaluate() {
      currentStarIndex.value = -1;
      comment.value = "";
    };
    var selectStar = function selectStar(starIndex) {
      if (currentStarIndex.value === starIndex) {
        currentStarIndex.value = currentStarIndex.value - 1;
      } else {
        currentStarIndex.value = starIndex;
      }
    };
    var submitEvaluate = function submitEvaluate() {
      var _currentConversation$, _currentConversation$2, _currentConversation$3, _container$value2;
      if (currentStarIndex.value < 0) {
        return;
      }
      var options = {
        to: (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$ = _currentConversation.value) === null || _currentConversation$ === void 0 || (_currentConversation$ = _currentConversation$.groupProfile) === null || _currentConversation$ === void 0 ? void 0 : _currentConversation$.groupID) || (_currentConversation === null || _currentConversation === void 0 || (_currentConversation$2 = _currentConversation.value) === null || _currentConversation$2 === void 0 || (_currentConversation$2 = _currentConversation$2.userProfile) === null || _currentConversation$2 === void 0 ? void 0 : _currentConversation$2.userID),
        conversationType: _currentConversation === null || _currentConversation === void 0 || (_currentConversation$3 = _currentConversation.value) === null || _currentConversation$3 === void 0 ? void 0 : _currentConversation$3.type,
        payload: {
          data: JSON.stringify({
            businessID: CHAT_MSG_CUSTOM_TYPE.EVALUATE,
            version: 1,
            score: currentStarIndex.value + 1,
            comment: comment.value
          }),
          description: "对本次的服务评价",
          extension: "对本次的服务评价"
        },
        needReadReceipt: isEnabledMessageReadReceiptGlobal()
      };
      TUIChatService.sendCustomMessage(options);
      // 提交后关闭 dialog
      // close dialog after submit evaluate
      container === null || container === void 0 || (_container$value2 = container.value) === null || _container$value2 === void 0 || _container$value2.toggleDialogDisplay(false);
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(ToolbarItemContainer, {
        iconFile: _unref(evaluateIcon),
        title: "评价",
        needBottomPopup: true,
        iconWidth: _unref(isUniFrameWork) ? '26px' : '20px',
        iconHeight: _unref(isUniFrameWork) ? '26px' : '20px',
        onOnDialogClose: onDialogClose,
        ref_key: "container",
        ref: container
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": _normalizeClass(['evaluate', !_unref(isPC) && 'evaluate-h5'])
          }, [_createElementVNode("div", {
            "class": _normalizeClass(['evaluate-header', !_unref(isPC) && 'evaluate-h5-header'])
          }, [_createElementVNode("div", {
            "class": _normalizeClass(['evaluate-header-content', !_unref(isPC) && 'evaluate-h5-header-content'])
          }, _toDisplayString(_unref(TUITranslateService).t("Evaluate.请对本次服务进行评价")), 3), !_unref(isPC) ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            "class": _normalizeClass(['evaluate-header-close', !_unref(isPC) && 'evaluate-h5-header-close']),
            onClick: _withModifiers(closeDialog, ["stop"])
          }, _toDisplayString(_unref(TUITranslateService).t("关闭")), 3)) : _createCommentVNode("", true)], 2), _createElementVNode("div", {
            "class": _normalizeClass(['evaluate-content', !_unref(isPC) && 'evaluate-h5-content'])
          }, [_createElementVNode("ul", {
            "class": _normalizeClass(['evaluate-content-list', !_unref(isPC) && 'evaluate-h5-content-list'])
          }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(starList), function (item, index) {
            return _openBlock(), _createElementBlock("li", {
              "class": _normalizeClass(['evaluate-content-list-item', !_unref(isPC) && 'evaluate-h5-content-list-item']),
              key: index,
              onClick: _withModifiers(function ($event) {
                return selectStar(index);
              }, ["stop"])
            }, [index <= _unref(currentStarIndex) ? (_openBlock(), _createBlock(Icon, {
              key: 0,
              file: _unref(starLightIcon),
              width: _unref(isPC) ? '20px' : '30px',
              height: _unref(isPC) ? '20px' : '30px'
            }, null, 8, ["file", "width", "height"])) : (_openBlock(), _createBlock(Icon, {
              key: 1,
              file: _unref(starIcon),
              width: _unref(isPC) ? '20px' : '30px',
              height: _unref(isPC) ? '20px' : '30px'
            }, null, 8, ["file", "width", "height"]))], 10, _hoisted_1);
          }), 128))], 2), _withDirectives(_createElementVNode("textarea", {
            "class": _normalizeClass(['evaluate-content-text', !_unref(isPC) && 'evaluate-h5-content-text']),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return _isRef(comment) ? comment.value = $event : null;
            })
          }, null, 2), [[_vModelText, _unref(comment)]]), _createElementVNode("div", {
            "class": _normalizeClass(['evaluate-content-button', !_unref(isPC) && 'evaluate-h5-content-button'])
          }, [_createElementVNode("button", {
            "class": "btn",
            onClick: submitEvaluate
          }, _toDisplayString(_unref(TUITranslateService).t("Evaluate.提交评价")), 1)], 2)], 2), _createElementVNode("div", {
            "class": _normalizeClass(['evaluate-adv', !_unref(isPC) && 'evaluate-h5-adv'])
          }, [_createTextVNode(_toDisplayString(_unref(TUITranslateService).t("Evaluate.服务评价工具")) + " " + _toDisplayString("(" + _unref(TUITranslateService).t("Evaluate.使用")) + " ", 1), _createElementVNode("a", {
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return openLink(_unref(Link).customMessage);
            })
          }, _toDisplayString(_unref(TUITranslateService).t("Evaluate.".concat(_unref(Link).customMessage.label))), 1), _createTextVNode(" " + _toDisplayString(_unref(TUITranslateService).t("Evaluate.搭建") + ")"), 1)], 2)], 2)];
        }),
        _: 1
      }, 8, ["iconFile", "iconWidth", "iconHeight"]);
    };
  }
});